<template>
  <div class="card" :class="classes">
    <a
      :href="product.onlineStoreUrl"
      class="media"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <ProductCardMedia
        :hover="hover"
        :primary-media="media"
        :secondary-media="hoverMedia"
      />

      <div v-if="hoverText" class="hover">
        <span class="link">{{ hoverText }}</span>
      </div>
    </a>

    <div class="info">
      <p class="info__title">{{ product.title }}</p>
      <ProductCardPrice :product="product" class="price" />
      <Link class="add-to-bag-btn" @click="handleAddToBagClick">
        Add To Bag
      </Link>
    </div>
  </div>
</template>

<script>
import Link from "@/components/Link.vue";
import ProductCardMedia from "@/components/product-card/ProductCardMedia.vue";
import ProductCardPrice from "@/components/product-card/ProductCardPrice.vue";
import { mapActions } from "vuex";

export default {
  name: "ProductCard",
  components: {
    ProductCardPrice,
    Link,
    ProductCardMedia,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    media: {
      type: Object,
      default: () => {},
    },
    hoverMedia: {
      type: Object,
      default: () => {},
    },
    textAlignment: {
      type: String,
      default: "left",
      validators: [(val) => ["center", "left"].includes(val)],
    },
    hoverText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    classes() {
      return {
        "card--center": this.textAlignment === "center",
      };
    },
  },
  methods: {
    ...mapActions("product", ["setProduct", "setOpenQuickLook"]),
    handleAddToBagClick() {
      this.setProduct(this.product);
      this.setOpenQuickLook(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  text-decoration: none;
}

.info {
  text-align: left;
  @include utility-label(15px);

  .card--center & {
    text-align: center;
  }
}

.media {
  display: block;
  aspect-ratio: 4/5;
  object-fit: cover;
  max-width: 100%;
  margin-bottom: 12px;
  background-color: $color-grey-light;
  position: relative;

  &:hover {
    .hover {
      @include respond-above(md) {
        display: block;
      }
    }
  }

  .hover {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);

    .link {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      @include utility-button(13px);
      display: inline-block;
      color: $color-white;
      border-bottom: 1px solid $color-white;
      padding: 4px 0;
      text-transform: uppercase;
    }
  }
}

.price {
  margin-top: 0px;
}

:deep(.media img),
:deep(.media video) {
  display: block;
  aspect-ratio: 4/5;
  object-fit: cover;
  max-width: 100%;
}

.add-to-bag-btn {
  margin-top: 12px;
}
</style>
